/**
 * Keeping a perspective view's width on narrow screens, as Unreal's "maintain
 * X FOV" (Aspect Ratio Axis Constraint) and Unity's gate fit do. A view's
 * field of view is vertical, so a portrait phone would otherwise crop the
 * sides of every shot, where the levels' panels stand. Below the aspect scenes
 * are framed at, a view keeps that aspect's horizontal angle and shows more
 * above and below instead.
 *
 * Both the editor's projection math and the renderer use this, so picking,
 * labels and what's drawn agree.
 */

/**
 * The aspect scenes are framed at: the desktop editor's viewport is about
 * 1.4:1 (where the levels were arranged), so 4:3 leaves desktop views as they
 * were and fits portrait phones and very narrow windows.
 */
export const FRAMED_ASPECT = 4 / 3;

/** Short of straight up and down, so a very narrow view stays a usable projection. */
const MAX_VERTICAL_FOV = 150;

/** The vertical field of view (degrees) to draw `fov` at on a viewport of this aspect. */
export function fittedVerticalFov(fov: number, aspect: number): number {
  if (aspect >= FRAMED_ASPECT || aspect <= 0) return fov;
  const halfTan = Math.tan((fov * Math.PI) / 360) * (FRAMED_ASPECT / aspect);
  return Math.min(MAX_VERTICAL_FOV, (2 * Math.atan(halfTan) * 180) / Math.PI);
}
